// Centralized brand & link configuration
export const BRAND = {
  name: "HypeSignals_4u",
  shortName: "HS",
  tagline: "Analiza rynku · sygnały tradingowe · edukacja",
  telegram: "https://t.me/+3Rn8lGB07PcwZWVk",
  instagram: "https://www.instagram.com/hypesygnaly/",
  okx: "https://my.okx.com/join/38382269",
};

// Pełny tekst klauzuli informacyjnej używany w kilku miejscach strony
export const RISK_DISCLOSURE =
  "Rynek kryptowalut wiąże się z wysokim ryzykiem straty kapitału. Materiały, analizy i sygnały mają charakter informacyjny i edukacyjny i nie stanowią indywidualnej porady inwestycyjnej. Przed podjęciem decyzji należy samodzielnie ocenić ryzyko.";

// Liczniki w sekcji statystyk — opisują skalę społeczności i częstotliwość publikacji,
// bez obietnic skuteczności czy zwrotu z inwestycji.
export const STATS = [
  {
    value: "900+",
    label: "Osób w społeczności",
    sub: "Zasięg kanałów HypeSignals_4u",
  },
  {
    value: "360+",
    label: "Członków grupy VIP",
    sub: "Zamknięta społeczność",
  },
  {
    value: "Codziennie",
    label: "Analizy i omówienia rynku",
    sub: "Publikowane w Telegramie",
  },
];

// Zrzuty rozmów z członkami społeczności (udostępnione za zgodą).
// Podpisy opisują charakter materiału, bez obietnic konkretnych rezultatów.
export const TESTIMONIALS = [
  {
    image:
      "https://customer-assets.emergentagent.com/job_crypto-sygnaly/artifacts/bd9o0ef5_841BF837-338E-4251-A337-8A2C06EC1B2D.jpg",
    caption: "Feedback z grupy VIP po dłuższym okresie w społeczności",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_crypto-sygnaly/artifacts/xz8d7gep_IMG_0513.jpg",
    caption: "Opinia członka grupy po omówieniach wykresów",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_crypto-sygnaly/artifacts/b3la7e64_82454ECD-3FCF-40B1-9EF5-5FAC79F837E7.jpg",
    caption: "Rozmowa na kanale po dyskusji o scenariuszu rynkowym",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_crypto-sygnaly/artifacts/8escvxpn_IMG_0707.jpg",
    caption: "Podsumowanie doświadczeń członka społeczności",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_crypto-sygnaly/artifacts/wxqqd3di_396335E6-F1B7-4F65-BCC1-2B9A1DFFED3C.jpg",
    caption: "Reakcja po omówieniu ETH/USDT w grupie",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_crypto-sygnaly/artifacts/znl5ohvz_IMG_9205.jpg",
    caption: "Wiadomość z czatu grupy VIP",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_crypto-sygnaly/artifacts/ho6p6l97_AF5563B9-A0AD-4A10-8AA3-082AA27C8423.jpg",
    caption: "Opinia o procesie nauki w ramach społeczności",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_crypto-sygnaly/artifacts/gle1qfop_IMG_9249.jpg",
    caption: "Fragment rozmowy po omówieniu scenariusza na BTC",
  },
  {
    image:
      "https://customer-assets.emergentagent.com/job_crypto-sygnaly/artifacts/nt0blbn2_F4095224-77A6-4C8B-BE38-64B0FFDD3353.jpg",
    caption: "Komentarz członka grupy do analizy altcoina",
  },
];

// Przykładowe schematy analityczne pokazywane w sekcji „Jak analizujemy rynek".
// Dane mają charakter poglądowy i edukacyjny — nie reprezentują faktycznych,
// zrealizowanych transakcji ani gwarantowanych rezultatów.
export const ANALYSIS_EXAMPLES = [
  {
    pair: "BTC/USDT",
    scenario: "Obserwacja struktury wyższego interwału",
    level: "Kluczowy opór w strefie poprzednich szczytów",
    invalidation: "Zamknięcie świecy D1 poniżej strefy wsparcia",
    status: "Scenariusz aktywny",
  },
  {
    pair: "ETH/USDT",
    scenario: "Reakcja na wcześniejszą strefę popytu",
    level: "Krawędź konsolidacji 4H",
    invalidation: "Utrata lokalnego minimum na 4H",
    status: "W obserwacji",
  },
  {
    pair: "SOL/USDT",
    scenario: "Powrót do średnioterminowej średniej",
    level: "Linia trendu z wyższego interwału",
    invalidation: "Przebicie strefy równowagi w dół",
    status: "Scenariusz zamknięty",
  },
  {
    pair: "AVAX/USDT",
    scenario: "Formacja kontynuacji trendu",
    level: "Strefa przebitego oporu jako wsparcie",
    invalidation: "Powrót pod poziom retestu",
    status: "W obserwacji",
  },
];
